module.exports = __webpack_public_path__ + "img/c02_unitfishingboat_Normal_ua.05c724d7.webp";